import { Dayjs } from "dayjs";

export interface Message {
    to?: Participant[];
    from?: string;
    id: ID;
    object: MessageObject;
    itemId?: ID;
    updatedAt?: Dayjs;
    type: MessageType;
    createdAt: Dayjs;
    formats?: MessageFormat[];
    channels?: string[];
    deletedAt?: Dayjs;
    inbound?: InboundDetails;
}

/** Carrier fields on a reply a traveler texted in. `sentFromNormalized` is digits-only E.164. */
export interface InboundDetails {
    sentFromNormalized?: string;
}

export enum MessageFormatType {
    EMAIL = "email",
    TEXT = "text",
    MEDIA = "media",
}

export interface MessageFormat {
    type: MessageFormatType;
    body?: string;
    subject?: string;
    asset?: Asset;
    email?: { id: ID };
}

export interface Asset {
    id: ID;
    path: string | null;
    name?: string;
    type: string;
}

export enum MessageType {
    EMAIL = "email",
    SMS = "sms",
}

export enum MessageObject {
    WAITLIST_INVITATION = "waitlist_invitation",
}

export interface Participant {
    id: ID;
    name: string;
    reminder?: number;
    tags?: string[];
    type?: number;
}
